export const DELAY = 1000;

export const ASSET_KEYS = ['departments', 'locations', 'groups', 'users', 'email_addresses'];
